import { ApiClient } from '@dozuki/web-js/utils';
import { QueryClient, useQuery } from '@tanstack/react-query';
import { useLocalization } from '~/framework';
import { getTeam, getTeamFromClient, GetTeamErrorCode } from '~/pages/api/teams/getTeam.api';
import { useApiErrorMessageToast } from '~/pages/_shared';

const KEY = 'team';

export function useTeam(teamid: number | null) {
   const { _js } = useLocalization();
   const { handleErrorOrRedirectToLogin } = useApiErrorMessageToast<GetTeamErrorCode>({
      'teams.team_not_found': _js('Could not find selected team'),
      default: _js('There was a problem retrieving the selected team; please try again'),
   });

   const queryFunction = async () => {
      if (!teamid) return null;
      return await getTeamFromClient(teamid);
   };

   return useQuery({
      queryFn: queryFunction,
      queryKey: [KEY, teamid],
      onError: handleErrorOrRedirectToLogin,
   });
}

export async function prefetchTeam(
   teamid: number,
   apiClient: ApiClient,
   queryClient: QueryClient
): Promise<void> {
   await queryClient.fetchQuery([KEY, teamid], () => getTeam(teamid, { apiClient }));
}
